<template>
  <base-data-table
    :headers="headers"
    :items="nas.data"
    :serverItemsLength="nas.total"
    :options.sync="options"
    :loading="isLoading"
    :nbItemsByPage="NB_ITEMS_BY_PAGE"
    containerId="#table-nas-container"
    itemClickRouterTarget="nas-details"
    :fixedHeaders="fixedHeaders"
    class="table-cursor"
    :item-class="handleClass"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            @click.stop="
              openInNewTab({
                name: 'logsradius-nas',
                params: { nasId: item.id },
              })
            "
          >
            <v-icon>$sav</v-icon>
          </v-btn>
        </template>
        <span>Voir les logs</span>
      </v-tooltip>
    </template>

    <template v-slot:item.nasType="{ item }">{{
      item.nasType.description
    }}</template>
    <template v-slot:item.portalDescription="{ item }">
      <router-link
        :to="{ name: 'portail-details', params: { id: item.portalId } }"
        >{{ item.portalDescription }}</router-link
      >
    </template>
    <template v-slot:item.lastAuthAt="{ item }">{{
      getInternationalDate(item.lastAuthAt)
    }}</template>
    <template v-slot:item.lastRequestAt="{ item }">{{
      getInternationalDate(item.lastRequestAt)
    }}</template>

    <template v-slot:item.privateIp="{ item }">
      <a
        @click.stop
        :href="'https://' + item.privateIp + ':444'"
        target="_blank"
        class="table-link"
      >
        {{ item.privateIp }}
      </a>
    </template>

    <template v-slot:item.adminLinks="{ item }">
      <div v-if="item.publicIp != null">
        <a
          @click.stop
          :href="'https://' + item.publicIp + ':444'"
          target="_blank"
          class="table-link"
        >
          444
        </a>
        <span> | </span>
        <a
          @click.stop
          :href="'https://' + item.publicIp + ''"
          target="_blank"
          class="table-link"
        >
          443
        </a>
        <span> | </span>
        <a
          @click.stop
          :href="'https://' + item.publicIp + ':8081'"
          target="_blank"
          class="table-link"
        >
          8081
        </a>
        <span> | </span>
        <a
          @click.stop
          :href="'https://' + item.publicIp + ':45443'"
          target="_blank"
          class="table-link"
        >
          45443
        </a>
      </div>
    </template>

    <template v-slot:item.active="{ item }">
      <span v-if="item.active == 1" class="green--text">Actif</span>
      <span v-else-if="item.active == 2" class="orange--text"
        >Bulle de silence</span
      >
      <span v-else class="red--text">Inactif</span>
    </template>
  </base-data-table>
</template>
<script>
import { useNas } from "@/composables/nas";
import { date } from "@/composables/date";
import { onMounted, watch, toRefs } from "@vue/composition-api";
import BaseDataTable from "@/components/General/BaseDataTable.vue";
import router from "@/router";
import { DateTime } from "luxon";

export default {
  components: {
    BaseDataTable,
  },
  props: {
    filterParams: Object,
    searchTerm: { type: String, default: null },
    partnerId: { type: Number, default: null },
    clientId: { type: Number, default: null },
    fixedHeaders: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    /* Import des API */
    const { deleteNas, nasData, listNas, nas } = useNas();
    const { getInternationalDate } = date();

    /* Variables */
    const NB_ITEMS_BY_PAGE = 100;

    /* Méthodes */
    const handleClass = (item) => {
      if (item.active == 0) {
        return "notActiveRow";
      } else {
        let durationFromNow = null;
        if (item.lastAuthAt != null) {
          const lastAuthAt = DateTime.fromISO(String(item.lastAuthAt));
          const nowDate = DateTime.now();
          const diff = nowDate.diff(lastAuthAt, ["hours"]);
          durationFromNow = diff.toObject().hours;

          console.log(durationFromNow);
        }

        if (durationFromNow > 1 && durationFromNow < 24) {
          return "warningRow";
        } else if (durationFromNow >= 24 && durationFromNow < 24 * 3) {
          return "orangeRow";
        } else if (durationFromNow >= 24 * 3 || durationFromNow == null) {
          return "dangerRow";
        }
      }
    };
    const openInNewTab = function (routeObj) {
      const routeData = router.resolve(routeObj);
      window.open(routeData.href, "_blank");
    };

    /* Cycle de vie */
    onMounted(async () => {
      await listNas(
        props.partnerId,
        props.clientId,
        props.searchTerm,
        props.filterParams
      );
      emit("display:nb-nas", nas.value.total);
    });

    /* Watchers */
    watch(
      [() => nasData.options, () => props.filterParams],
      async (newValues, oldValues) => {
        if (oldValues[0].page !== undefined) {
          await listNas(
            props.partnerId,
            props.clientId,
            props.searchTerm,
            props.filterParams
          );
          emit("display:nb-nas", nas.value.total);
        }
      },
      {
        deep: true,
      }
    );

    return {
      getInternationalDate,
      handleClass,
      headers: [
        { text: "NAS-ID", value: "nasIdentifier" },
        {
          text: "Description",
          value: "description",
          sortable: false,
          width: "10%",
        },
        { text: "Etat", value: "active" },
        { text: "IP publique", value: "publicIp" },
        { text: "IP VPN", value: "privateIp" },
        { text: "Admin", value: "adminLinks" },
        { text: "Type", value: "nasType" },
        { text: "Dernière Auth.", value: "lastAuthAt" },
        { text: "Dernière Requête", value: "lastRequestAt" },
        { text: "Action", value: "actions", sortable: false },
      ],
      deleteNas,
      ...toRefs(nasData),
      nas,
      NB_ITEMS_BY_PAGE,
      openInNewTab,
    };
  },
};
</script>
<style scoped>
.table-cursor::v-deep .activeRow {
}

.table-cursor::v-deep .warningRow {
  background-color: #feea392b;
}
.table-cursor::v-deep .orangeRow {
  background-color: #ff980042;
}
.table-cursor::v-deep .dangerRow {
  background-color: #f4433626;
}

.table-cursor::v-deep .notActiveRow {
  background-color: #9e9e9e;
}
.table-cursor::v-deep tbody {
  cursor: pointer;
}
</style>
